import React from "react";

export default class KierowcaFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }

        this.filter = this.filter.bind(this);
        this.isFiltered = this.isFiltered.bind(this);
    }

    filter(event) {
        this.setState({value: event.target.value})
        if (this.refs.kierowcaInput.value === '') {
            this.props.filterHandler();
        } else {
            this.props.filterHandler({callback: this.isFiltered});
        }
    }

    isFiltered(targetValue) {
        for (let i=0; i<targetValue.length; i++){
            if ((targetValue[i].kierowca.imie + ' ' + targetValue[i].kierowca.nazwisko).toLowerCase().indexOf(this.refs.kierowcaInput.value.toLowerCase()) >=0 ) {
                return targetValue
            }
        }

    }

    render() {
        return (
            <div>
                <input ref='kierowcaInput' type='text' className='form-control' placeholder='Szukaj'
                       value={this.state.value} onChange={this.filter}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/zarzadzanie/filters/KierowcaFilter.js